var readmore = document.getElementsByClassName("readmore");
var readless = document.getElementsByClassName("readless");

var read_more = function() {
    document.querySelectorAll(".full-content").forEach(element => {
        element.classList.remove("hideContent");
    });
    document.querySelectorAll(".short-content").forEach(element => {
        element.classList.add("hideContent");
    });
};

var read_less = function() {
    document.querySelectorAll(".short-content").forEach(element => {
        element.classList.remove("hideContent");
    });
    document.querySelectorAll(".full-content").forEach(element => {
        element.classList.add("hideContent");
    });
};

for (var i = 0; i < readmore.length; i++) {
    readmore[i].addEventListener('click', read_more, false);
}

for (var i = 0; i < readless.length; i++) {
    readless[i].addEventListener('click', read_less, false);
}